import React from "react";
import {
  withSitecoreContext
} from "@sitecore-jss/sitecore-jss-react";
import "./index.scss";
const ModularDataTable = (props) => {
  const marginTop = props?.params?.TopMargin ? `margin-top__${props?.params?.TopMargin}` : "";
  const marginBottom = props?.params?.BottomMargin ? `margin-bottom__${props?.params?.BottomMargin}` : "";
  return (
    <section className={`modular-data-table section-space container ${marginTop} ${marginBottom}`} id={props?.rendering?.dataSource} dangerouslySetInnerHTML={{__html: props?.fields?.Table?.value}}>
    </section>
  );
};

export default withSitecoreContext()(ModularDataTable);
